import { Form } from './forms.interface'
import { getFormsState, getUpdateFormState } from './forms.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import ListTrait from 'src/app/traits/list.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'
import {
  FetchFormsRequest,
  DeleteFormRequest,
  SetDefaultData,
  UpdateField,
  FetchFormRequest,
} from './forms.actions'

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.css'],
})
export class FormsComponent extends ListTrait implements OnInit, OnDestroy {
  private state$: Subscription
  private formState$: Subscription
  private route$: Subscription
  private shouldReload: boolean = false
  public isLoading: boolean = false
  public isPreviewOpen: boolean
  public columns: object[] = [
    {
      prop: 'name',
      name: 'NAME',
      sortable: true,
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]
  private duplicateRequested: boolean
  public previewData: any
  options: any = {
    path: '/assets/loader.json',
  }

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store.pipe(select(getFormsState)).subscribe((state) => {
      this.state = state
      this.isLoading = state.get('isLoading')
      if (
        state.get('shouldReload') != this.shouldReload &&
        state.get('shouldReload')
      ) {
        this.runFilter()
      }
      this.shouldReload = state.get('shouldReload')
    })

    this.formState$ = this.store
      .pipe(select(getUpdateFormState))
      .subscribe((state) => {
        if (
          !state.get('isLoading') &&
          !!state.get('data')?.size &&
          this.duplicateRequested
        ) {
          this.store.dispatch(
            new UpdateField(
              'data',
              state
                .get('data')
                .set('name', `${state.get('data').get('name')} Copy`)
                .toJS(),
              'createForm',
            ),
          )
          this.store.dispatch<any>(new SetDefaultData('updateForm'))
          this.store.dispatch(
            new UpdateField('isDuplicate', true, 'createForm'),
          )
          this.duplicateRequested = false
          this.router.navigate(['/admin/forms/create'])
        } else if (
          !state.get('isLoading') &&
          !!state.get('data')?.size &&
          this.isPreviewOpen
        ) {
          this.previewData = state.get('data')
        }
      })

    this.route$ = this.route.queryParams.subscribe(this.runFilter.bind(this))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
    this.formState$.unsubscribe()

    this.duplicateRequested = false
    this.isPreviewOpen = false
    this.previewData = null
  }
  get previewForm() {
    return this.previewData && this.previewData.get('form')
  }
  runFilter(queryParams: any = {}) {
    const { page, page_size } = this.state.get('queryParams').toJS()
    const params = { page, page_size, ...queryParams }

    this.store.dispatch<any>(
      new FetchFormsRequest({
        filters: {
          ...(params.keyword
            ? {
                or: [{ field: 'name', value: params.keyword }],
              }
            : {}),
        },
        pageSize: parseInt(params.page_size, 10),
        page: parseInt(params.page, 10) - 1,
        sort: {
          order: params.sort?.toUpperCase(),
          prop: params.order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('queryParams', params, 'list'))
  }

  deleteUser(id: number) {
    this.store.dispatch(new DeleteFormRequest(id))
  }

  duplicate(row: Map<string, any>) {
    this.duplicateRequested = true
    this.store.dispatch<any>(new FetchFormRequest(row.get('id')))
  }

  preview(row: Map<string, any>) {
    this.isPreviewOpen = true
    this.previewData = null
    this.store.dispatch<any>(new FetchFormRequest(row.get('id')))
  }
}
